module.exports = __webpack_public_path__ + "img/A17b_20180249-007_1.622d8200.jpg";